import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Note: React.StrictMode removed intentionally. It causes double-mount/unmount
// cycles that break the Amazon Chime SDK (video calls go white, uncaught errors
// from SDK internals). The Chime SDK's meeting lifecycle is not compatible with
// Strict Mode's effect replay behavior.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
